<template>
  <div  >
    <div class="mpay" v-if="isMobile">

      <div :class="isShowMe?'orderDetails':'orderDetails hide'">
      <div :class="isShowMe?'detailList-bg':'detailList-bg hide'"></div>
      <div class="mdetailList">
          <div>
            <template v-if="ewm==''">
            <p>
              <span >{{Game}}</span>

              -报名费用：{{Bal}}元 <i @click="closeWindow()" class="el-icon el-icon-close"></i></p>
            <ul>
              <!-- <template v-if="isWeiXin()">
                 <li @click="callpay()"><img class="vam" src="../assets/wxpay.png" width="55%"><span>微信支付</span></li>
                 <li><img class="vam" src="../assets/wxpay.png" width="55%"><span>微信支付(维护中)</span></li>
              </template>
              <template v-else-if="IsPC()">
                 <li @click="wxpayEwm()"><img class="vam" src="../assets/wxpay.png" width="55%"><span>微信扫码支付</span></li>
              </template>
              <template v-else>
                  <li @click="wxpayH5()"><img class="vam" src="../assets/wxpay.png" width="55%"><span>微信支付</span></li>
              </template> -->

               <li @click="aliSubmit()"><img class="vam" src="../assets/alipay.png" width="55%"><span>支付宝扫码支付(推荐)</span></li>
               <li @click="wxpayEwm(true)"><img class="vam" src="../assets/wxpay.png" width="55%"><span>微信扫码支付</span></li>

            </ul>
            </template>
            <template v-else>
              <p>报名费用：{{Bal}}元 <i @click="closeWindow()" class="el-icon el-icon-close"></i></p>
              <div class="ewm"><img class="vam" :src="ewm" ><span>打开微信扫一扫</span></div>
            </template>

             <template v-if="IsMySignUpPage">
                <div :class="ewm==''?'btn-pay':'btn-pay1'"><a href="javascript:void(0);" @click="shuaxin()">已完成支付</a></div>
             </template>
             <template v-else>
                <div :class="ewm==''?'btn-pay':'btn-pay1'"><router-link to="/my-sign-up" >已完成支付</router-link></div>
             </template>
          </div>
      </div>
    </div>
    <div class="alipaycode" v-html="code"></div>

    </div>
    <div class="pay" v-else>
    <div :class="isShowMe?'orderDetails':'orderDetails hide'">
      <div :class="isShowMe?'detailList-bg':'detailList-bg hide'"></div>
      <div class="detailList">
          <div>
            <template v-if="ewm==''">
            <p>
              <span >{{Game}}</span>

              -报名费用：{{Bal}}元 <i @click="closeWindow()" class="el-icon el-icon-close"></i></p>
            <ul>
              <!-- <template v-if="isWeiXin()">
                <li @click="callpay()"><img class="vam" src="../assets/wxpay.png" width="55%"><span>微信支付</span></li>
                <li><img class="vam" src="../assets/wxpay.png" width="55%"><span>微信支付(维护中)</span></li>
              </template>
              <template v-else-if="IsPC()">
                 <li @click="wxpay()"><img class="vam" src="../assets/wxpay.png" width="55%"><span>微信扫码支付</span></li>
              </template>
              <template v-else>
                  <li @click="wxpayH5()"><img class="vam" src="../assets/wxpay.png" width="55%"><span>微信支付</span></li>
              </template> -->
              <li @click="aliSubmit()"><img class="vam" src="../assets/alipay.png" width="55%"><span>支付宝扫码支付(推荐)</span></li>
              <li @click="wxpayEwm(false)"><img class="vam" src="../assets/wxpay.png" width="55%"><span>微信扫码支付</span></li>
            </ul>
            </template>
            <template v-else>
              <p>报名费用：{{Bal}}元 <i @click="closeWindow()" class="el-icon el-icon-close"></i></p>
              <div class="ewm"><img class="vam" :src="ewm" ><span>打开微信扫一扫</span></div>
            </template>

             <template v-if="IsMySignUpPage">
                <div :class="ewm==''?'btn-pay':'btn-pay1'"><a href="javascript:void(0);" @click="shuaxin()">已完成支付</a></div>
             </template>
             <template v-else>
                <div :class="ewm==''?'btn-pay':'btn-pay1'"><router-link to="/my-sign-up" >已完成支付</router-link></div>
             </template>
          </div>
      </div>
    </div>
    <div class="alipaycode" v-html="code"></div>
  </div>

  </div>


</template>

<script>
export default {
  name: 'pay',
  props:{
    isShow:Boolean,
    Bal:Number,
    ID:Number,
    IsMySignUpPage:Boolean,
    GameID:String,
    Game:String
  },
  data () {
    return {
       isShowMe:this.isShow,
       ewm:'',
       code:'',
       openId:'',
    }
  },
  computed:{
    loading(){
				return this.$store.getters.loadingPara;
    },
    isMobile(){
       return this.common.isMobile();
    }
  },
  methods: {
    closeWindow(){
      this.isShowMe=false;
    },
    shuaxin(){
      this.$emit("on-reload");
    },
    wxpay(){
      const self = this;
      var data= self.common.GetlocalStorage("UnLockUserData");
      var userId=JSON.parse(data).UserID;
      const loading = this.$loading(this.loading);
      self.http.ajaxGet("WxPay?UserID="+userId+"&ID="+self.ID,function(res){
          loading.close();
          if(res.ReturnCode == 1){
            var arr=res.Message.toString().split("|");
            self.ewm=res.Result;
          }else{
            self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
          }
        },function(err){
          loading.close();
          self.$alert(err, '错误', {confirmButtonText: '确定'});
      })
    },
    wxpayEwm(isMobile){
      //长沙立风信息公司
      const self = this;
      var data= self.common.GetlocalStorage("UnLockUserData");
      var userId=JSON.parse(data).UserID;
      const loading = this.$loading(this.loading);
      self.http.ajaxGet("WxPay3?UserID="+userId+"&ID="+self.ID,function(res){
          loading.close();
          if(res.ReturnCode == 1){
            if(isMobile){
            var src=res.Message;
            self.$alert('<div class="mfuli"><h2>保存二维码，使用微信扫一扫<br />识别二维码付款即可</h2><p class="pay"><img src="'+src+'" width="50%" /></p><ul class="pay"><li>保存该界面二维码</li><li>打开微信，打开扫一扫</li><li>识别完成后，完成付款即可</li></ul><div>', '', {
              dangerouslyUseHTMLString: true,
              showClose:true,
              confirmButtonText:"",
              showCancelButton:false,
              showConfirmButton:false,
              confirmButtonClass:"fr",
              customClass:'mfuli-message-box'
            }).catch(() => {});
          }else{
            var src=res.Message;
            self.$alert('<div class="fuli"><h2>打开手机微信扫一扫<br />识别二维码继续付款</h2><p class="pay"><img src="'+src+'" width="50%" /></p><div>', '', {
              dangerouslyUseHTMLString: true,
              showClose:true,
              confirmButtonText:"",
              showCancelButton:false,
              showConfirmButton:false,
              confirmButtonClass:"fr"
            }).catch(() => {});
          }
          }else{
            self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
          }
        },function(err){
          loading.close();
          self.$alert(err, '错误', {confirmButtonText: '确定'});
      })

    },
    wxpayH5(){
      const self = this;
      var data= self.common.GetlocalStorage("UnLockUserData");
      var userId=JSON.parse(data).UserID;
      const loading = this.$loading(this.loading);
      self.http.ajaxGet("WxPayH5?UserID="+userId+"&ID="+self.ID,function(res){
          loading.close();
          if(res.ReturnCode == 1){
            window.location.href=res.Result;
          }else{
            self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
          }
        },function(err){
          loading.close();
          self.$alert(err, '错误', {confirmButtonText: '确定'});
      })
    },
    alipay(){
      const self = this;
      var data= self.common.GetlocalStorage("UnLockUserData");
      var userId=JSON.parse(data).UserID;
      const loading = this.$loading(this.loading);
      self.http.ajaxGet("AliPay?UserID="+userId+"&ID="+self.ID,function(res){
          loading.close();
          if(res.ReturnCode == 1){
            self.code=res.Result;
          }else{
            self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
          }
        },function(err){
          loading.close();
          self.$alert(err, '错误', {confirmButtonText: '确定'});
      })
    },
    aliSubmit(){
      document.forms['alipaysubmit'].submit();
    },
    isWeiXin(){
				var ua = window.navigator.userAgent.toLowerCase();
				if (ua.match(/MicroMessenger/i) == 'micromessenger') {
					return true;
				} else {
					return false;
				}
    },
    IsPC(){
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
            "SymbianOS", "Windows Phone",
            "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
		wxCode(){
        var self=this;
        const loading = this.$loading(this.loading);
        var str=this.getQueryVariable("code");
				var json={"Path":window.location.href,"Code":str };
				this.http.ajaxPost('WxCode',json,"",function(data){
					loading.close();
					if(data.ReturnCode == 1){
						window.location.href=data.Result;
          }
          else if(data.ReturnCode == 10){
            self.openId=data.Result;
          }
          else{
						self.$alert(data.Message, '温馨提示', {confirmButtonText: '确定'});
					}
				},function(res){ loading.close();self.$alert(res, '错误', {confirmButtonText: '确定'});});
			},
			getQueryVariable(variable){
				var query = window.location.search.substring(1);
				var vars = query.split("&");
				for (var i=0;i<vars.length;i++) {
						var pair = vars[i].split("=");
						if(pair[0] == variable){return pair[1];}
				}
				return("");
      },
      jsApiCall(){
        //JSAPI
        const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				const loading = this.$loading(this.loading);
				self.http.ajaxGet("WxjsapiPay?UserID="+userId+"&ID="+self.ID+"&OpenID="+self.openId,function(res){
					loading.close();
					if(res.ReturnCode == 1){
             var data =JSON.parse(res.Result);
             WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
              "appId":data.appId,     //公众号名称，由商户传入
              "timeStamp":data.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":data.nonceStr, //随机串
              "package":data.package,
              "signType":data.signType,         //微信签名方式：
              "paySign":data.paySign //微信签名
            } ,
            function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    self.$alert("支付成功", '温馨提示', {confirmButtonText: '确定'});
                } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                    self.$alert("支付过程中用户取消", '温馨提示', {confirmButtonText: '确定'});
                } else if (res.err_msg == "get_brand_wcpay_request:fail") {
                    self.$alert("支付失败", '温馨提示', {confirmButtonText: '确定'});
                }
            });
					}else{
						self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
					}
					},function(err){
					loading.close();
					self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
      },
      callpay(){
          const self=this;
          if (typeof WeixinJSBridge == "undefined")
          {
              if (document.addEventListener)
              {
                  document.addEventListener('WeixinJSBridgeReady', self.jsApiCall, false);
              }
              else if (document.attachEvent)
              {
                  document.attachEvent('WeixinJSBridgeReady', self.jsApiCall);
                  document.attachEvent('onWeixinJSBridgeReady', self.jsApiCall);
              }
          }
          else
          {
              self.jsApiCall();
          }
      }
  },
  watch: {
    isShow(val) {
      if(val){
          this.alipay();
      }
      this.isShowMe = val;
    },
    isShowMe(val){
      this.$emit("on-close",val);
    }
  },
  mounted: function () {
      //如果是微信内置浏览器
      if(this.isWeiXin()){
         //获取code
         this.wxCode();
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .detailList-bg{position:fixed;width:100%;height:100%;bottom:0;left:0; background:#000;filter:alpha(opacity=50); -moz-opacity:0.5; opacity: 0.5; margin:0; padding:0; z-index:9; }
	.detailList{width:320px;height:350px;position: fixed; top:50%; left:50%; margin-left:-160px; margin-top:-175px;  z-index:10; background: #fff; border-radius: 5px; }
  .detailList .dl-close{ margin-right:25px; margin-top:8px;}
  .pay ul{ overflow: hidden;}
  .pay li{float: left; width:50%;text-align: center; cursor: pointer;}
  .pay li span{ display: block; color:#a7a7a7; font-size:14px; padding-top:20px; }
  .pay p{ font-size:16px; height:100px; text-align: center; line-height:100px; color:#161616;}
  .pay .djs{ font-size:16px; height:70px; text-align: center; line-height:70px; color:#161616;}
  .pay i{  font-size:20px; position: absolute; right:5%; top:5%; cursor: pointer;}
  .pay .btn-pay{text-align: center; margin-top:40px;}
  .pay .btn-pay1{text-align: center; margin-top:30px;}
  .pay a{background: #188fff;color:#fff; width:100px; height:32px; line-height:32px; text-align: center; display:block; border-radius: 3px;font-size:14px; margin:0 auto; }
  .pay .ewm{text-align: center;}
  .pay .ewm img{ padding:5px; border:solid 1px #ccc;}
  .pay .ewm span{display: block;color:#a7a7a7; font-size:14px; padding-top:10px;}
  .pay .alipaycode{ display:none;}

  .mdetailList{width:22rem;height:22rem;position: fixed; top:50%; left:50%; margin-left:-11rem; margin-top:-11rem;  z-index:10; background: #fff; border-radius: 5px; }
  .mdetailList .dl-close{ margin-right:1.2rem; margin-top:0.8rem;}
  .mpay ul{ overflow: hidden;}
  .mpay li{float: left; width:50%;text-align: center; cursor: pointer;}
  .mpay li span{ display: block; color:#a7a7a7; font-size:1.2rem; padding-top:1rem; }
  .mpay p{ font-size:1.2rem; height:6rem; text-align: center; line-height:6rem; color:#161616;}
  .mpay .djs{ font-size:1.2rem; height:3.5rem; text-align: center; line-height:3.5rem; color:#161616;}
  .mpay i{  font-size:1rem; position: absolute; right:5%; top:5%; cursor: pointer;}
  .mpay .btn-pay{text-align: center; margin-top:2rem;}
  .mpay .btn-pay1{text-align: center; margin-top:1.5rem;}
  .mpay a{background: #188fff;color:#fff; width:50%; height:3rem; line-height:3rem; text-align: center; display:block; border-radius: 3px;font-size:1.2rem; margin:0 auto; }
  .mpay .ewm{text-align: center;}
  .mpay .ewm img{ padding:5px; border:solid 1px #ccc;}
  .mpay .ewm span{display: block;color:#a7a7a7; font-size:1.2rem; padding-top:0.5rem;}
  .mpay .alipaycode{ display:none;}
</style>



// WEBPACK FOOTER //
// src/components/pay.vue